import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { Link, useLocation, useNavigate } from "react-router";
import { Loading } from "../components/Loading/Loading";
import { useAuth } from "@/hooks/useAuth";
import { useOnChange } from "@/hooks/useOnChange";



export function LeftMenu(props: { readonly onNavigate: () => void; }) {
	const { setAuth } = useAuth();
	const navigate = useNavigate();


	const cerrarSesion = () => {
		setAuth(null);
		void navigate("/login");
	};

	return (
		<>
			<div className="gn-scroller">
				<div className="menu" style={{ display: "flex", flexDirection: "column" }}>
					<div className="menu-titlePanel">
						PANEL DE CONTROL
					</div>

					<MenuItems onNavigate={props.onNavigate} />
				</div>
			</div>

			<div className="bottom-bnts">
				<button className="cerrarSesion" onClick={cerrarSesion} type="button">
					<i className="fa fa-power-off" />
					<span>Cerrar sesión</span>
				</button>
				<div className="iconoWunder">
					<img src="/img/icons/newLogoWunder.svg" alt="Wunder Logo" />
				</div>
			</div>
		</>
	);
}

function MenuItems(props: { readonly onNavigate: () => void; }) {
	const { data: response, isPending, isError } = useAccesosMenu();

	const menuItems = useMemo(() => {
		if (response == null) return response;
		return structuredClone(itemsMenu)
			.filter(item => {
				if (item.subItems == null) {
					// Es un ítem individual, comprobar si está en la respuesta
					return response.includes(item.id);
				} else {
					// Es un menú con sub-items, filtrar sus sub-items
					item.subItems = item.subItems.filter(subItem => response.includes(subItem.id));
					return true;
				}
			});
	}, [response]);

	if (isPending) return <Loading style={{ color: "white" }} />;
	if (isError || menuItems == null) return <div>Error loading menu</div>;

	return (
		<>
			{menuItems.map((item) => (
				<LineaMenu key={item.id} menuData={item} onNavigate={props.onNavigate} />
			))}
		</>
	);
}


function LineaMenu(props: { readonly menuData: MenuItemMulti | MenuItemSingle, readonly onNavigate: () => void; }) {
	const { menuData, onNavigate } = props;

	if (menuData.subItems == null) return <LineaMenuSingle menuData={menuData} onNavigate={onNavigate} />;
	if (menuData.subItems.length === 0) return;
	if (menuData.subItems.length === 1) {
		return (
			<LineaMenuSingle
				menuData={{
					...menuData,
					id: menuData.subItems[0].id,
					url: menuData.subItems[0].url,
					subItems: null,
				}}
				onNavigate={onNavigate}
			/>
		);
	}

	return <LineaMenuMulti menuData={menuData} onNavigate={onNavigate} />;
}

function LineaMenuSingle(props: { readonly menuData: MenuItemSingle, readonly onNavigate: () => void; }) {
	return (
		<li className="menu-item menu-item-parent" style={{ order: props.menuData.order }}>
			<Link to={props.menuData.url} onClick={props.onNavigate}>
				<img src={props.menuData.icon} className="menu-icon" />
				<div>
					<span className="menu-title">{props.menuData.title}</span>
					<span className="menu-description">{props.menuData.description}</span>
				</div>
				<img />
			</Link>
		</li>
	);
}

function LineaMenuMulti(props: { readonly menuData: MenuItemMulti, readonly onNavigate: () => void; }) {
	const [open, setOpen] = useState(false);
	const onClickSubMenu = (event: React.MouseEvent) => {
		event.preventDefault();
		setOpen(!open);
	};

	const location = useLocation();
	useOnChange(location, () => { setOpen(false); });


	return (
		<li className="menu-item menu-item-parent" style={{ order: props.menuData.order }}>
			<a className="has-submenu" href="#" onClick={onClickSubMenu}>
				<img src={props.menuData.icon} className="menu-icon" />
				<div>
					<span className="menu-title">{props.menuData.title}</span>
					<span className="menu-description">{props.menuData.description}</span>
				</div>
				<img src="/img/icons/arrowright.svg" className="submenu-arrow-icon" style={{ transform: open ? "rotate(90deg)" : "rotate(0deg)" }} />
			</a>
			<div className="submenu" style={{ display: open ? "block" : "none" }}>
				{props.menuData.subItems.map((subItem) => (
					<SubLineaMenu key={subItem.id} subItem={subItem} onNavigate={props.onNavigate} />
				))}
			</div>
		</li>
	);
}

function SubLineaMenu(props: { readonly subItem: SubMenuItem, readonly onNavigate: () => void; }) {
	return (
		<div className="menu-item-child">
			<Link to={props.subItem.url} onClick={props.onNavigate}>
				<div className="menu-icon" />
				<div>
					<span className="menu-title">{props.subItem.title}</span>
					<span className="menu-description">{props.subItem.description}</span>
				</div>
				<img />
			</Link>
		</div>
	);

}


let order = 1;
const itemsMenu: Array<MenuItemMulti | MenuItemSingle> = [
	{
		id: "VistaAlmacen",
		url: "/order",
		icon: "/img/icons/gestArts.svg",
		title: "Gestion de Artículos",
		description: "Cree órdenes de compra y fabricación",
		order: order++,
	},
	{
		id: "PedidosVenta",
		icon: "/img/icons/pedidosVenta.svg",
		title: "Pedidos de venta",
		description: "Gestione los artículos y pedidos",
		order: order++,
		subItems: [
			{
				id: "LanzarPedidos",
				url: "/cycles",
				// icon: "",
				title: "Lanzar ciclos",
				description: "Gestione las agrupaciones de órdenes de fabricación",
				order: order++
			},
			{
				id: "AsignarPedidos",
				url: "/factory",
				// icon: "",
				title: "Asignar ciclos",
				description: "Asigne ciclos a operarios",
				order: order++
			},
			{
				id: "Empaquetado",
				url: "/empaquetadop",
				// icon: "",
				title: "Empaquetado",
				description: "Cree estructuras para los paquetes de expedición",
				order: order++
			}
		]
	},
	{
		id: "Produccion",
		icon: "/img/icons/produccion.svg",
		title: "Producción",
		description: "Gestione las órdenes de fabricación",
		order: order++,
		subItems: [
			{
				id: "GestionOFs",
				url: "/ordermanager",
				// icon: "",
				title: "Gestión de OFs",
				description: "Impute producciones a órdenes de fabricación",
				order: order++
			},
			{
				id: "GestionPuestos",
				url: "/gestionfases",
				// icon: "",
				title: "Gestión de Puestos",
				description: "Ordene e imprima las órdenes de fabricación por puestos",
				order: order++
			},
			{
				id: "GestionOPEs",
				url: "/opes",
				// icon: "",
				title: "Listado de OPEs",
				description: "Gestione órdenes de fabricación externa",
				order: order++
			}
		]
	},
	{
		id: "Configuracion",
		icon: "/img/icons/configuracion.svg",
		title: "Configuración",
		description: "Configure usuarios y almacenes",
		order: order++,
		subItems: [
			{
				id: "GestionUsuarios",
				url: "/users",
				// icon: "",
				title: "Usuarios",
				description: "Gestione todos los usuarios",
				order: order++
			},
			{
				id: "GestionUbicaciones",
				url: "/locationmanager",
				// icon: "",
				title: "Gestión de ubicaciones",
				description: "Gestione las ubicaciones de los almacenes",
				order: order++
			},
			{
				id: "GestionSubPuestos",
				url: "/workstation",
				// icon: "",
				title: "Gestión de sub-puestos",
				description: "Gestione los puestos de producción",
				order: order++
			},
			{
				id: "SincronizarAlmacenes",
				url: "/syncro",
				// icon: "",
				title: "Sincronizar almacenes",
				description: "Sincronice los stocks entre almacenes",
				order: order++
			},
			{
				id: "FamiliasOcultas",
				url: "/FamiliasOcultas",
				// icon: "",
				title: "Familias Ocultas",
				description: "Gestione las familias ocultas globales",
				// eslint-disable-next-line no-useless-assignment -- Basically like a trailing comma
				order: order++
			},
		]
	}
];

interface MenuItemMulti {
	id: string;
	url?: null;
	icon: string;
	title: string;
	description: string;
	order: number;
	subItems: SubMenuItem[];
}
interface MenuItemSingle {
	id: string;
	url: string;
	icon: string;
	title: string;
	description: string;
	order: number;
	subItems?: null;
}
interface SubMenuItem {
	id: string;
	url: string;
	// icon: string;
	title: string;
	description: string;
	order: number;
}


function useAccesosMenu() {
	return useQuery<string[]>({
		queryKey: ["getMenusRol"],
		queryFn: () => sendAjaxRequest("GET", "/api/v1/getMenusRol"),
	});
}